<template>
    <div v-if="quick_url.urls&&quick_url.urls.length==2&&$common.trademark" class="url-container" :style="{'color':quick_url.color}">
        <div class="warning-msg">即将访问下列网站，该网站可能存在风险</div>
        <div class="single-url">{{quick_url.urls[0].url}}</div>
        <div class="btn-container">
            <Button label="访问该网址" rounded @click="gotoUrl(quick_url.urls[0].url)" :style="{'width':'50%'}"/>
        </div>
    </div>
    <div v-if="quick_url.urls&&quick_url.urls.length>2" class="url-container">
        <div class="warning-msg" :style="{'color':quick_url.color}">下列网站的部分或者全部可能存在风险，点击每项复制其链接，然后在浏览器中打开</div>
        <div class="url-list">
            <div v-for="(url,i) in quick_url.urls" :key="i" :hidden="i==quick_url.urls.length-1">
               <div class="url" @click="gotoUrl(url.url)">
                    <div>
                        <div class="title">{{url.title}}</div>
                        <div class="link">{{url.url}}</div>
                    </div>
                    <span class="iconfont icon-fuzhi" style="font-size: 2.5rem"></span>
               </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button';

export default {
  name: 'QuickUrl',
  components: {
    Button
  },
  data(){
    return {

    }
  },
  props: {
    quick_url: null
  },
  methods:{
    gotoUrl(url){

      window.location.href=url;

    }
  },
  created(){
    
    if(this.quick_url.urls.length==2&&!this.$common.trademark)
    {
      window.location.href=this.quick_url.urls[0].url;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.url-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding:10px;
}
.warning-msg{
    text-align: center;
}
.single-url{
    background-color: rgba(0,0,0,0.1);
    border-radius: 5px;
    padding:2rem;
    margin:2rem 0;
    width:100%;
    text-align: center;
}

.btn-container{
    width:100%;
    text-align: center;
    margin-top:1rem;
}
.url-list{
    background-color: #fcfcfc;
    border: 1px solid #dee2e6;
    border-radius: 10px !important;
    width:100%;
    padding:0 1rem;
    margin:2rem 0;

}

.url{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ebebeb;
    padding:10px;
}
.url-list:last-child{
    border-bottom: 0px solid rgba(0,0,0,1);
}
</style>